import { apiFetch } from "../Utility/api";

export const getNowLocalDateTime = () => {
  const now = new Date();
  const timezoneOffset = now.getTimezoneOffset() * 60000;
  return new Date(now.getTime() - timezoneOffset).toISOString().slice(0, 16);
};

export const defaultMealForm = () => ({
  eatenAt: getNowLocalDateTime(),
  mealType: "Breakfast",
  notes: "",
  recipeId: "",
  servingsEaten: "1",
  manualItemName: "",
  manualIngredientText: "",
});

export const defaultSymptomForm = () => ({
  startedAt: getNowLocalDateTime(),
  endedAt: "",
  symptomType: "Bloating",
  severity: "5",
  notes: "",
});

export const defaultBowelEventForm = () => ({
  occurredAt: getNowLocalDateTime(),
  stoolFormScale: "4",
  urgency: "5",
  painSeverity: "4",
  bloodPresent: false,
  mucusPresent: false,
  notes: "",
});

export const defaultDailyContextForm = () => ({
  contextDate: new Date().toISOString().slice(0, 10),
  sleepHours: "",
  stressLevel: "5",
  exerciseMinutes: "",
  caffeineServings: "",
  alcoholServings: "",
  notes: "",
});

export const parseManualIngredients = (manualIngredientText) =>
  manualIngredientText
    .split("\n")
    .map((line) => line.trim())
    .filter(Boolean)
    .map((line) => ({
      name: line,
      quantityText: "",
      quantityValue: null,
      unit: "",
      preparationNote: "",
    }));

export const fetchDiaryMeals = async () => {
  const response = await apiFetch("/food/diary/meals");
  return response.json();
};

export const fetchDiarySymptoms = async () => {
  const response = await apiFetch("/food/diary/symptoms");
  return response.json();
};

export const fetchRecipes = async () => {
  const response = await apiFetch("/food/server");
  return response.json();
};

export const fetchBowelEvents = async () => {
  const response = await apiFetch("/food/diary/bowel-events");
  return response.json();
};

export const fetchDailyContext = async () => {
  const response = await apiFetch("/food/diary/daily-context");
  return response.json();
};
